import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import LuckyDrawWinnerActions from '../reducers/luckyDrawWinnerReducer'

export function* getLuckyDrawWinners({payload}) {
  yield put(LuckyDrawWinnerActions.setWinnerLoading(true))

  const {startFrom, endAt} = payload
  try{
    const winnersRef = firebase
      .firestore()
      .collection('lucky_draw_winners')
      .where('created_at', '>=', startFrom)
      .where('created_at', '<=', endAt)
      .orderBy('created_at')

    const snapShot = yield call([winnersRef, winnersRef.get])
    const winners = {}

    snapShot.forEach(doc => {

      winners[doc.id] = {...doc.data(), id: doc.id}
    })

  yield put(LuckyDrawWinnerActions.setLuckyDrawWinners(winners))

  } catch(error) {
    yield put(LuckyDrawWinnerActions.setWinnerLoading(false))
  }

}


// WEBPACK FOOTER //
// ./src/sagas/luckyDrawWinnerSaga.js